import request from '@/utils/request'

// 查询列表
export function apiScpMrpSystemItemsList (data) {
  return request({
    url: '/scp/scpMrpSystemItems/list',
    method: 'post',
    data: data
  })
}

// 导出列表
export function apiScpMrpSystemItemsNewExport (data) {
  return request({
    url: '/scp/scpMrpSystemItems/v2/export',
    method: 'post',
    data: data
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}
